import Page from '@shell/Page'
import DefaultTemplate from '@order/steps/templates/Default/DefaultTemplate'
import { StepOptions } from '@order/steps/types'

const options: StepOptions = [
  {
    id: '1',
    title: 'Standard Glasses',
    name: '1',
    desc: 'Vision in the budget range',
    image: require('@/images/packages/standard.png'),
    nextStep: 1,
    select: {
      oId: '1',
    },
    colorOption: 'gray',
  },
  {
    id: '2',
    name: '2',
    title: 'Premium Glasses',
    desc: 'Including wider viewing areas',
    image: require('@/images/packages/premium.png'),
    pricePrefix: 'from',
    price: {
      base: 199,
    },
    nextStep: 1,
    select: {
      oId: '1',
    },
    colorOption: 'green',
  },
  {
    id: '3',
    name: '3',
    title: 'High-End Glasses',
    desc: 'Higher level of visual comfort',
    image: require('@/images/packages/high-end.png'),
    pricePrefix: 'only',
    price: {
      base: 399,
      discounted: 299,
      applied: [
        {
          type: 'percentage',
          amount: 25,
        },
      ],
    },
    nextStep: 1,
    select: {
      oId: '1',
    },
    colorOption: 'magenta',
  },
  {
    id: '4',
    name: '4',
    title: 'World-Class Glasses',
    desc: 'Best eyewear equipment possible!',
    image: require('@/images/packages/steiner.png'),
    // pricePrefix: 'from',
    price: {
      base: 599,
      discounted: 300,
      applied: [
        {
          type: 'percentage',
          amount: 50,
        },
      ],
    },
    recommended: true,
    nextStep: 1,
    select: {
      oId: '1',
    },
    colorOption: 'blue',
  },
  {
    id: '5',
    name: '5',
    title: 'TGBO',
    desc: 'Payment as Installments',
    image: require('@/images/packages/steiner.png'),
    priceSuffix: 'monthly',
    price: {
      base: 599,
      discounted: 300,
      applied: [
        {
          type: 'percentage',
          amount: 50,
        },
      ],
    },
    // recommended: true,
    // nextStep: 1,
    // select: {
    //   oId: '1',
    // },
    colorOption: 'blue',
  },
]

export default function DevOptionsPage() {
  return (
    <Page stage="dev">
      <DefaultTemplate
        title="Upgrade Deal"
        desc="Would you like to upgrade your selected Deal? Improve your visual comfort and choose the best eyewear!"
        options={options}
      />
    </Page>
  )
}
